import request from '@/api/config/request'

const prex = "api/admin/gestao/nfse_nacional_envios";

export function listEnviosAdn(query = {}) {
    return request({
        url: `${prex}`,
        method: 'get',
        params: query
    })
}

export function reenviarAdn(data) {
    return request({
        url: `${prex}`,
        method: 'post',
        data
    })
}
